import { f as functionUncurryThis } from './function-uncurry-this.js';

var uncurryThis = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis({}.isPrototypeOf);

export { objectIsPrototypeOf as o };
//# sourceMappingURL=object-is-prototype-of.js.map
